import AddPartIconSVG from "../../../SharedComponents/assets/icons/svg/AddPartIconSVG.js";
import { FontEnum } from "../../utils/enums/FontEnum.js";
import { OrderPartVariantDivEnum } from "../../utils/enums/OrderPartDivVariantEnum.js";
import { useNavigate } from 'react-router-dom';



const OrderPartLinkDiv = ({ variant }) => {
    const navigate = useNavigate();

    const getProperBackgroundColor = () => {
        let color = "";

        if (variant === OrderPartVariantDivEnum.YELLOW) {
            color = "#D3E205";
        };

        if (variant === OrderPartVariantDivEnum.BLUE) {
            color = "#94BFFE";
        };

        return color;
    };

    const mainContainerStyle = {
        ...styles.mainContainer,
        backgroundColor: getProperBackgroundColor()
    };

    return (
        <div style={mainContainerStyle} onClick={() => navigate('/order-part')}>
            <div style={styles.container} />

            <div style={styles.textContainer}>
                <p style={styles.textStyle}>
                    Naruči deo
                </p>
            </div>

            <div style={styles.iconContainer}>
                <AddPartIconSVG />
            </div>
        </div>
    );
};

export default OrderPartLinkDiv;

const styles = {
    mainContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 8,
        borderRadius: 10,
        cursor: 'pointer'
    },
    container: {
        flex: 1
    },
    textContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    textStyle: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "20px",
        fontWeight: 700,
        flex: 2,
        color: '#000000'
    },
    iconContainer: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
};